import React from 'react';
import './AlertsModal.scss';
import './Modal.scss';
import { AlertNotification } from '../Alerts/AlertNotification';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  overdueEventsList: any[];
  fiveMinsList: any[];
  alertNotificationCLicked: (event: any) => void;
}

const AlertsModal: React.FC<ModalProps> = ({ isOpen, onClose, overdueEventsList, fiveMinsList, alertNotificationCLicked }) => {
  if (!isOpen) return null;
      
  return (
    <div className="positioned-alerts-modal-div-container">
    <div className="filter-header">
                <div className="filter-title">
                    <span>Activity</span>
                </div>
                <div style={{"height": "20px"}}><button className="filter-close-icon" onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.39705 5.55379L5.46967 5.46967C5.73594 5.2034 6.1526 5.1792 6.44621 5.39705L6.53033 5.46967L12 10.939L17.4697 5.46967C17.7359 5.2034 18.1526 5.1792 18.4462 5.39705L18.5303 5.46967C18.7966 5.73594 18.8208 6.1526 18.6029 6.44621L18.5303 6.53033L13.061 12L18.5303 17.4697C18.7966 17.7359 18.8208 18.1526 18.6029 18.4462L18.5303 18.5303C18.2641 18.7966 17.8474 18.8208 17.5538 18.6029L17.4697 18.5303L12 13.061L6.53033 18.5303C6.26406 18.7966 5.8474 18.8208 5.55379 18.6029L5.46967 18.5303C5.2034 18.2641 5.1792 17.8474 5.39705 17.5538L5.46967 17.4697L10.939 12L5.46967 6.53033C5.2034 6.26406 5.1792 5.8474 5.39705 5.55379L5.46967 5.46967L5.39705 5.55379Z" fill="#626B79"/>
                    </svg>
                </button>
                </div>
            </div>
          {overdueEventsList.length === 0 && fiveMinsList.length === 0 && 
        <div className="filter-sort-container-root a no-notfications-modal-container">
          <div className='no-notification-section'>
            <div className='no-notification-icon-container'>
              <svg xmlns="http://www.w3.org/2000/svg" width="88" height="100" viewBox="0 0 88 100" fill="none">
                <path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M44 0C46.1094 0 47.8527 1.56752 48.1286 3.60127L48.1667 4.16667L48.1701 12.7167C64.8442 14.4834 75.9445 26.9014 75.9445 44.4444C76.1136 51.76 77.4106 60.5595 79.9651 65.6266L80.5318 66.6534L86.3651 75.4806C88.088 78.0877 86.4297 81.5131 83.4605 81.907L82.8889 81.9445H56.4986L56.5 87.5C56.5 94.2456 50.7456 100 44 100C37.5354 100 31.9813 94.7152 31.5296 88.3377L31.5 87.5L31.4986 81.9445H5.11113C1.98617 81.9445 0.0426874 78.6724 1.35101 75.9781L1.63493 75.4806L7.38331 66.7874C10.6077 61.4792 12.0556 52.8218 12.0556 44.4444C12.5964 27.5957 23.5739 14.6309 39.8338 12.7383L39.8333 4.16667C39.8333 1.86548 41.6988 0 44 0ZM48.1653 81.9445H39.8319L39.8333 87.5C39.8333 89.6432 41.8568 91.6667 44 91.6667C45.9647 91.6667 47.8286 89.9664 48.1256 88.0322L48.1667 87.5L48.1653 81.9445ZM44 20.8333C30.057 20.8333 20.9372 29.5431 20.4128 43.1903L20.3889 44.4444L20.3665 46.4027C20.1707 54.8893 18.678 63.336 15.2471 69.7938L14.4207 71.2478L12.8556 73.6111H75.1389L73.4944 71.1138C69.8164 65.0589 68.0819 56.7413 67.6958 48.229L67.6335 46.4027L67.6111 44.4444C67.6111 30.079 58.3655 20.8333 44 20.8333Z" fill="#00274A" fillOpacity="0.15" />
              </svg>
            </div>
            <div className='no-notification-text'>You have no new notifications at this time </div>
            </div>
        </div>}
         { !(overdueEventsList.length === 0 && fiveMinsList.length === 0 ) && <div className='filter-sort-container-root b alert-modal-minheight'>
          {overdueEventsList.length > 0 && 
              <AlertNotification data={overdueEventsList} category={"Overdue Events"} alertNotificationCLicked={alertNotificationCLicked}/>
          }
          {fiveMinsList.length > 0 &&
              <AlertNotification data={fiveMinsList} category={"Within 5 mins"} alertNotificationCLicked={alertNotificationCLicked}/>
          }
          </div>
}
    </div>
  );
};

export default AlertsModal;